/**
 * ZONE API — Wrapper dei REST Liferay delle zone commerciali.
 *
 * Contratto backend (rest-openapi.yaml):
 *   - GET    /zones/{groupId}            -> Page<Zone>
 *   - POST   /zones/{groupId}  ZoneInput -> Zone
 *   - PATCH  /zone/{zoneId}    ZoneInput (parziale) -> Zone
 *   - DELETE /zone/{zoneId}              -> 200 (scollega le aziende)
 *   - GET    /zone/{zoneId}/businesses   -> Page<ZoneBusiness>
 *   - POST   /zone/{zoneId}/regions      ZoneRegionInput -> ZoneRegion
 *   - PATCH  /zone-region/{zoneRegionId} ZoneRegionInput (parziale) -> ZoneRegion
 *   - DELETE /zone-region/{zoneRegionId} -> 200
 *   - GET    /provinces                  -> Page<Province>
 *   - GET    /zone-users                 -> Page<ZoneUser>
 */

import type { Page } from '@crm/shared';
import { httpClient } from '../../api/httpClient';
import type {
  Province,
  Zone,
  ZoneBusiness,
  ZoneCreatePayload,
  ZoneRegion,
  ZoneRegionPayload,
  ZoneUpdatePayload,
  ZoneUser,
} from './zoneTypes';

export const zoneApi = {
  list: (groupId: number): Promise<Zone[]> =>
    httpClient.get<Page<Zone>>(`/zones/${groupId}`).then((r) => r.data.items),
  create: (groupId: number, payload: ZoneCreatePayload): Promise<Zone> =>
    httpClient.post<Zone>(`/zones/${groupId}`, payload).then((r) => r.data),
  update: (zoneId: number, payload: ZoneUpdatePayload): Promise<Zone> =>
    httpClient.patch<Zone>(`/zone/${zoneId}`, payload).then((r) => r.data),
  remove: (zoneId: number): Promise<void> =>
    httpClient.delete(`/zone/${zoneId}`).then(() => undefined),
  businesses: (zoneId: number): Promise<ZoneBusiness[]> =>
    httpClient.get<Page<ZoneBusiness>>(`/zone/${zoneId}/businesses`).then((r) => r.data.items),
  addRegion: (zoneId: number, payload: ZoneRegionPayload): Promise<ZoneRegion> =>
    httpClient.post<ZoneRegion>(`/zone/${zoneId}/regions`, payload).then((r) => r.data),
  updateRegion: (zoneRegionId: number, payload: ZoneRegionPayload): Promise<ZoneRegion> =>
    httpClient.patch<ZoneRegion>(`/zone-region/${zoneRegionId}`, payload).then((r) => r.data),
  removeRegion: (zoneRegionId: number): Promise<void> =>
    httpClient.delete(`/zone-region/${zoneRegionId}`).then(() => undefined),
  provinces: (): Promise<Province[]> =>
    httpClient.get<Page<Province>>('/provinces').then((r) => r.data.items),
  users: (): Promise<ZoneUser[]> =>
    httpClient.get<Page<ZoneUser>>('/zone-users').then((r) => r.data.items),
};
